module.exports = "/_next/static/images/Hero@2x-5b5f3855a90c23e54e22d1d483609b1b.webp";